'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDay$002dOf$002dWeek$002dUtils$0024 from "./presto.types$-Day-Of-Week-Utils$.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$$anon$191() {
  this.cf4 = null;
  this.cf2 = null;
  this.cf3 = false;
  this.cf0 = null;
  this.cf1 = false;
  this.cf5 = false;
  this.cf6 = false;
  this.cf4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$proto$$anon$191 as $c_Lpresto_types$proto$$anon$191 };
$p = $c_Lpresto_types$proto$$anon$191.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$$anon$191;
/** @constructor */
function $h_Lpresto_types$proto$$anon$191() {
}
export { $h_Lpresto_types$proto$$anon$191 as $h_Lpresto_types$proto$$anon$191 };
$h_Lpresto_types$proto$$anon$191.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.cf4;
});
$p.t = (function() {
  if ((!this.cf3)) {
    this.cf2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("days", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cf3 = true;
  }
  return this.cf2;
});
$p.ae = (function() {
  if ((!this.cf1)) {
    this.cf0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().a2G(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dDay$002dOf$002dWeek$002dUtils$0024.$m_Lpresto_types$DayOfWeekUtils$().cI2()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cf1 = true;
  }
  return this.cf0;
});
$p.w = (function() {
  if ((!this.cf6)) {
    this.cf5 = false;
    this.cf6 = true;
  }
  return this.cf5;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_types$proto$$anon$191 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$$anon$191, "presto.types$proto$$anon$191", ({
  a2X: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$proto$$anon$191 as $d_Lpresto_types$proto$$anon$191 };
//# sourceMappingURL=presto.types$proto$$anon$191.js.map
